import { render, staticRenderFns } from "./Topicos.vue?vue&type=template&id=c6d36cd0&scoped=true"
import script from "./Topicos.vue?vue&type=script&lang=js"
export * from "./Topicos.vue?vue&type=script&lang=js"
import style0 from "./Topicos.vue?vue&type=style&index=0&id=c6d36cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d36cd0",
  null
  
)

export default component.exports